import { Injectable, inject } from "@angular/core";
import { UrlService } from "./url.service";
import { Category } from "src/app/routes/catalog/models/category.model";
import { Product } from "src/app/routes/catalog/models/product.model";
import { Page } from "../models/page.model";

export type BreadcrumbItem = (Category | Product | Page) & { url: string };

@Injectable({
  providedIn: "root",
})
export class BreadcrumbService {
  private urlService = inject(UrlService);

  getItem(data: Category | Product | Page): BreadcrumbItem {
    return { ...data, url: this.urlService.get(data) };
  }

  getItems(data?: Category | Product | Page | null): BreadcrumbItem[] {
    if (data && data.parent) {
      return [...this.getItems(data.parent), this.getItem(data)];
    } else if (data) {
      return [this.getItem(data)];
    }
    return [];
  }
}
